import PropTypes from 'prop-types';

import { makeonMouseEnterForNonTouchDevices } from 'helpers';
import ProductUtils from 'helpers/ProductUtils';

import cssStyles from 'styles/components/productdetail/addToFavoritesButton.scss';

const AddToFavoritesButton = (props, { testId }) => {
  const { action, colorId, onAddToFavorites, sizing, selectedSizing, showSelectSizeTooltip, hideSelectSizeTooltip, mouseEnterFactory } = props;
  let stockId = '';
  let onHand = 1;
  if (ProductUtils.isSizeSelectionComplete(sizing, selectedSizing)) {
    const stock = ProductUtils.getStockBySize(sizing.stockData, colorId, selectedSizing);
    if (stock) {
      stockId = stock.id;
    } else {
      onHand = 0;
    }
  }
  const showTooltipHandler = mouseEnterFactory(showSelectSizeTooltip);
  return (
    <div className={cssStyles.addToFavorites}>
      <form action={action} method="GET" onSubmit={onAddToFavorites}>
        <input type="hidden" name="stockId" value={stockId}/>
        <button
          type="submit"
          disabled={onHand < 1}
          className={cssStyles.addToFavoritesButton}
          onMouseEnter={showTooltipHandler}
          onMouseLeave={hideSelectSizeTooltip}
          onFocus={showTooltipHandler}
          onBlur={hideSelectSizeTooltip}
          data-track-action="Product-Page"
          data-track-label="PrForm"
          data-track-value="Add-To-Favorites"
          data-test-id={testId('addToFavorites')}>
          Add to Favorites
        </button>
      </form>
    </div>
  );
};

AddToFavoritesButton.contextTypes = {
  testId: PropTypes.func
};

AddToFavoritesButton.defaultProps = {
  mouseEnterFactory: makeonMouseEnterForNonTouchDevices
};

AddToFavoritesButton.propTypes = {
  action: PropTypes.string.isRequired,
  sizing: PropTypes.object.isRequired,
  selectedSizing: PropTypes.object.isRequired,
  colorId: PropTypes.string.isRequired,
  onAddToFavorites: PropTypes.func.isRequired,
  showSelectSizeTooltip: PropTypes.func.isRequired,
  hideSelectSizeTooltip: PropTypes.func.isRequired
};

export default AddToFavoritesButton;
